shadow$provide[375] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying float vClipProximity;

void clipProximityFragment() {
  if (vClipProximity >= 0.5) discard;
}`;

};